// core/loader.service.ts
import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {
  
 private activeCount = 0;
 public readonly _loading = signal<boolean>(false);

 loading = this._loading.asReadonly();

 show(): void {
   this.activeCount++;
   if (!this._loading()) this._loading.set(true);
 }

 hide(): void {
   this.activeCount = Math.max(0, this.activeCount - 1);
   if (this.activeCount === 0 && this._loading()) {
     this._loading.set(false);
   }
 }

 reset(): void {
   this.activeCount = 0;
   this._loading.set(false);
 }
}